import { inject, Injectable } from '@angular/core';
import { BackendDataSourceService } from '@ntap/core';

import { TreeNode } from 'primeng/api';
import { forkJoin, map, Observable } from 'rxjs';

type ObjektProp = {
  'earhiv~spremiste_objekt~id': number;
  'earhiv~spremiste_objekt~identifikator': string;
  'earhiv~spremiste_objekt~naziv': string;
};
type ProstorijaProp = {
  'earhiv~spremiste_prostorija~id': number;
  'earhiv~spremiste_prostorija~identifikator': string;
  'earhiv~spremiste_prostorija~naziv': string;
  'earhiv~spremiste_prostorija~spremiste_objekt_id': number;
};

type SpremisnaJedinicaProp = {
  'earhiv~spremiste_spremisna_jedinica~id': number;
  'earhiv~spremiste_spremisna_jedinica~identifikator': string;
  'earhiv~spremiste_spremisna_jedinica~naziv': string;
  'earhiv~spremiste_spremisna_jedinica~spremiste_prostorija_id': number;
};

type LokacijaProp = {
  'earhiv~spremiste_lokacija~id': number;
  'earhiv~spremiste_lokacija~identifikator': string;
  'earhiv~spremiste_lokacija~naziv': string;
  'earhiv~spremiste_lokacija~spremiste_spremisna_jedinica_id': number;
};
type BackendDataObjectProp = {
  objekti: ObjektProp[];
  prostorije: ProstorijaProp[];
  spremisne_jedinice: SpremisnaJedinicaProp[];
  lokacije: LokacijaProp[];
};

@Injectable()
export class SpremisteLocationsNodeService {
  backendService = inject(BackendDataSourceService);
  locationsArray$: Observable<TreeNode[]>;

  getSpremisteLocations(item: any) {
    const backendDataObject: BackendDataObjectProp = {
      objekti: [],
      prostorije: [],
      spremisne_jedinice: [],
      lokacije: []
    };

    const state = { ['en~fizicki_objekt~id']: item['en~fizicki_objekt~id'] };

    this.locationsArray$ = forkJoin([
      this.backendService.getViewData('objekti_spremista', state),
      this.backendService.getViewData('prostorije_spremista', state),
      this.backendService.getViewData('spremisne_jedinice_spremista', state),
      this.backendService.getViewData('lokacije_spremista', state)
    ]).pipe(
      map(
        ([
          objektiData,
          prostorijeData,
          spremisneJediniceData,
          lokacijeData
        ]) => {
          backendDataObject.objekti = objektiData as ObjektProp[];
          backendDataObject.prostorije = prostorijeData as ProstorijaProp[];
          backendDataObject.spremisne_jedinice =
            spremisneJediniceData as SpremisnaJedinicaProp[];
          backendDataObject.lokacije = lokacijeData as LokacijaProp[];

          // Transformation logic to create newArray for TreeSelect component
          const newArray = backendDataObject.objekti.map((objekt) => {
            const children = backendDataObject.prostorije
              .filter(
                (prostorija) =>
                  prostorija[
                    'earhiv~spremiste_prostorija~spremiste_objekt_id'
                  ] === objekt['earhiv~spremiste_objekt~id']
              )
              .map((prostorija) => {
                const spremisneJedinice = backendDataObject.spremisne_jedinice
                  .filter(
                    (spremisnaJedinica) =>
                      spremisnaJedinica[
                        'earhiv~spremiste_spremisna_jedinica~spremiste_prostorija_id'
                      ] === prostorija['earhiv~spremiste_prostorija~id']
                  )
                  .map((spremisnaJedinica) => {
                    const lokacije = backendDataObject.lokacije
                      .filter(
                        (lokacija) =>
                          lokacija[
                            'earhiv~spremiste_lokacija~spremiste_spremisna_jedinica_id'
                          ] ===
                          spremisnaJedinica[
                            'earhiv~spremiste_spremisna_jedinica~id'
                          ]
                      )
                      .map((lokacija) => {
                        return {
                          label: `${
                            lokacija['earhiv~spremiste_lokacija~identifikator']
                          } ${
                            lokacija['earhiv~spremiste_lokacija~naziv'] || ''
                          }`,
                          data: lokacija['earhiv~spremiste_lokacija~id'],
                          expandedIcon: 'pi pi-th-large',
                          collapsedIcon: 'pi pi-th-large'
                        };
                      });

                    return {
                      label: `${
                        spremisnaJedinica[
                          'earhiv~spremiste_spremisna_jedinica~identifikator'
                        ]
                      } ${
                        spremisnaJedinica[
                          'earhiv~spremiste_spremisna_jedinica~naziv'
                        ] || ''
                      }`,
                      data: spremisnaJedinica[
                        'earhiv~spremiste_spremisna_jedinica~id'
                      ],
                      expandedIcon: 'pi pi-box',
                      collapsedIcon: 'pi pi-box',
                      children: lokacije
                    };
                  });

                return {
                  label: `${
                    prostorija['earhiv~spremiste_prostorija~identifikator']
                  } ${prostorija['earhiv~spremiste_prostorija~naziv'] || ''}`,
                  data: prostorija['earhiv~spremiste_prostorija~id'],
                  expandedIcon: 'pi pi-sitemap',
                  collapsedIcon: 'pi pi-sitemap',
                  children: spremisneJedinice
                };
              });

            return {
              label: `${objekt['earhiv~spremiste_objekt~identifikator']} ${
                objekt['earhiv~spremiste_objekt~naziv'] || ''
              }`,
              data: objekt['earhiv~spremiste_objekt~id'],
              expandedIcon: 'pi pi-building',
              collapsedIcon: 'pi pi-building',
              children: children
            };
          });
          return newArray;
        }
      )
    );
    return this.locationsArray$;
  }
}
